import { UpdateBrandCompanyInputType } from "~/types/data/BrandCompany.type";

export const validateUpdateBrandCompany = (
  input: UpdateBrandCompanyInputType
) => {
  if (!input.name) return "Name can't be empty.";

  if (!input.id) return "Id can't be empty.";
};
